import { t } from 'i18next';
import { useCallback } from 'react';
import { toast } from 'react-toastify';

export function useCopyToClipboard() {
    const copy = useCallback(async (text: string): Promise<boolean> => {
        try {
            await navigator.clipboard.writeText(text);
            toast.success(t("SUCCESSFULLY_COPIED"));
            return true;
        } catch (err) {
            console.error('Copy to clipboard failed:', err);
            toast.error(t("Failed to copy to clipboard"));
            return false;
        }
    }, []);

    return { copy };
}
